import list from 'src/modules/formCategory/list/formCategoryListReducers';
import form from 'src/modules/formCategory/form/formCategoryFormReducers';
import view from 'src/modules/formCategory/view/formCategoryViewReducers';
import destroy from 'src/modules/formCategory/destroy/formCategoryDestroyReducers';
import importerReducer from 'src/modules/formCategory/importer/formCategoryImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
